<template>
  <div class="tw:h-screen tw:flex tw:flex-col">
    <RegisterHeader />
    <RegisterForm />
  </div>
</template>

<script lang="ts" setup>
import { onMounted, onUnmounted } from "vue";
import RegisterHeader from "vue-app-new/modules/Register/components/RegisterHeader/RegisterHeader.vue";
import RegisterForm from "vue-app-new/modules/Register/features/RegisterForm/RegisterForm.vue";
import { saveUtmToCookies, removeUtmFromCookies } from "vue-app-new/modules/Register/Register.helpers";

const handleBeforeUnload = () => {
  removeUtmFromCookies();
};

onMounted(() => {
  window.addEventListener("beforeunload", handleBeforeUnload);
  saveUtmToCookies();
});

onUnmounted(() => {
  window.removeEventListener("beforeunload", handleBeforeUnload);
});
</script>

<style>
@media (max-width: 768px) {
  html {
    font-size: 16px !important;
  }
}

@media (min-width: 768px) {
  html {
    font-size: 12px !important;
  }
}

@media (min-width: 1024px) {
  html {
    font-size: 12px !important;
  }
}

@media (min-width: 1280px) {
  html {
    font-size: 12px !important;
  }
}

@media (min-width: 1536px) {
  html {
    font-size: 16px !important;
  }
}

@media (min-width: 1920px) {
  html {
    font-size: 17px !important;
  }
  .EdroneButton {
    height: 100% !important;
  }
}

@media (min-width: 2560px) {
  html {
    font-size: 24px !important;
  }
}

@media (min-width: 3840px) {
  html {
    font-size: 32px !important;
  }
}

@media (min-width: 5120px) {
  html {
    font-size: 36px !important;
  }
}
</style>
